import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const Root = ({ component }) => {
  return (
    <div className="flex flex-col">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto lg:ml-[339px]">
          {/* <Outlet /> */}
          {component}
        </main>
      </div>
    </div>
  );
};

export default Root;
